import { render, staticRenderFns } from "./LayoutDrawerCustomiseCoverFormBicycles.vue?vue&type=template&id=6971dc07&scoped=true&"
import script from "./LayoutDrawerCustomiseCoverFormBicycles.vue?vue&type=script&lang=js&"
export * from "./LayoutDrawerCustomiseCoverFormBicycles.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6971dc07",
  null
  
)

export default component.exports